module.exports = ".rowcss {\n  padding-left: 0px !important; }\n\n.field {\n  margin-top: 5px; }\n\n.modal-header {\n  padding: 5px !important; }\n\n#Newaddpost {\n  margin: 30px auto; }\n\n#Newaddpre {\n  margin: 30px auto; }\n\n#ContractExtension {\n  margin: 30px auto; }\n\n#alert {\n  margin: 30px auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/postPoned-form/postPoned-form.component.scss
// module id = ./client/app/postPoned-form/postPoned-form.component.scss
// module chunks = main